define('views/modules/calendar/animated-session/animation/animation-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // src
    'services/viewport',
    'services/user',
    // events
    'services/events/animated-session-events',
    // collections
    'collections/calendar/session/animations',
    'collections/calendar/session/custom-animations',
    'collections/calendar/session/tags',
    // models
    'models/calendar/session/tag',
    'models/calendar/session/animation',
    // Views
    'views/parts/menu/menu-action',
    'views/parts/form/multi-select',
    'views/parts/form/textbox',
    'views/modules/calendar/animated-session/animation/lists/animation-list',
    'views/modules/calendar/animated-session/custom-exercises-manager/edit/custom-exercise-edit-panel',
    'views/parts/alert/alert-list',
    // Templates Blocks
    'text!templates/modules/calendar/animated-session/animation/animation-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // service
    Viewport,
    User,
    // events
    AnimationEvents,
    // collections
    CAnimations,
    CCustomAnimations,
    CTags,
    MAnimation,
    // models
    MTag,
    // Views
    VMenuAction,
    VMultiSelect,
    VTextbox,
    VExerciseAnimationList,
    VCustomExerciseEditPanel,
    VAlertList,
    // Template
    TAnimationContent
) {

    var VExerciseAnimationContent = Backbone.View.extend({

        // id: "menu",
        template: TAnimationContent,

        // abstracting selectors out of the view logic
        events: {
            "click #btnSearch": "onSubmitSearch",
        },
        regions: {
            root: "#exercise-search-content",
            menu: ".menu-actions",
            search: "#exercise-search",
            searchText: "#exercise-text-search",
            //searchTextbox: "#exercise-search-textbox",
            btnSearch: "#btnSearch",
            alert: '.alert-list',
            list: "#exercise-result-list"
        },

        initialize: function(opt) {
            this.options = opt = _.extend({ custom: false }, opt);

            var AnimationsConstructor = opt.custom ? CCustomAnimations : CAnimations;

            _.extend(this, {
                tags: new CTags({ async: false }),
                custom: opt.custom,
                group: opt.group,
                collection: new AnimationsConstructor(),
                actionCollection: new Backbone.Collection([
                    { content: 'calendar:Add exercises', icon: 'fa fa-check', btnClass: "btn-tc-custom", itemClass: "btn-action-md btn-add-exercises pull-right", callback: this.onAddSelectedExercisesClick },
                    //{ route: '#', title: i18n.t('messages:tooltip-search'), icon: 'sl-icon-magnifier', toggle: true, callback: this.onSearchAction },
                    { content: 'messages:tooltip-cancel', itemClass: "pull-right btn-action-md hide-btn-action btn-cancel", btnClass: "btn-default ", callback: this.onRemoveSelectedExercisesClick }
                ])
            });

            if (this.custom && this.group.isSupervisor()) {
                this.actionCollection.unshift({
                    title: i18n.t('calendar:Add a custom exercise'),
                    content: '<strong>+</strong>',
                    skipTranslation: true,
                    itemClass: 'big-action',
                    callback: this.onAddCustomExerciseAction
                });
            }

            var tagIdAttribute = MTag.prototype.idAttribute,
                collection = this.collection,
                view = this.view = {
                    search: new VMultiSelect({
                        label: "Search",
                        collection: this.tags,
                        subgroup: "subtags",
                        fetch: true,
                        option: { label: "trName", value: tagIdAttribute, },
                        optgroup: { label: "trName", value: tagIdAttribute, },
                        searchField: "trName",
                        context: this,
                        onUpdate: this.onFilterUpdate,
                        placeholder: 'Search for anything here'
                    }),
                    searchText: new VTextbox({ help: this.options.custom ? "" : "search-help", label: 'Search-by-keyword', attribute: 'query', autofocus: true }),
                    alert: new VAlertList(),
                    list: new VExerciseAnimationList({
                        collection: collection,
                        tags: this.tags,
                        group: this.group,
                        custom: opt.custom
                    }),
                    menu: new VMenuAction({
                        context: this,
                        onClick: this.onActionClick,
                        radio: false,
                        collection: this.actionCollection,
                        tooltip: { container: this.regions.root, }
                    }),
                };


            this.listenTo(view.list, { 'selected:change': this.onExerciseSelect })
                .listenTo(collection, { 'sync': this.onCollectionSync })
                .listenTo(collection, { 'reset': this.onCollectionSync });
            this.listenTo(view.searchText, 'change', this.onChange);
            this.listenTo(view.searchText, 'submit', this.onQuerySubmit);
        },

        render: function() {
            var html = Mustache.render(this.template,
                                      Mustache.getContext(_.extend({ isCustom: this.options.custom })));
            this.$el.empty().append(html);

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.list, zone.$list)
                .assign(view.alert, zone.$alert);

            //Pour le moment, les Custom Exercices ne sont reliee a aucun tag, on zappe donc le dropdown de recherche
            if (!this.custom) {
              this.collection.resetFilter();
              this.view.search.resetSelectedTags();
              this.assign(view.search, zone.$search);
              this.setStartSearchMsg();
            } else {
                this.assign(view.searchText, zone.$searchText);
            }

            this.view.searchText.setValue("");
            this.currentQuery = "";

            return this;
        },

        restoreFilter: function() {
            var searchText = this.view.searchText.getValue(),
                applyFilter = false,
                tags = "";

            if (!_.isEmpty(searchText)) {
                this.collection.searchText = searchText;
                applyFilter = true;
            }

            if (applyFilter) {
              this.view.list.render();
              this.view.alert.reset();
            }

        },

        setStartSearchMsg: function() {
          var view = this.view.alert;
          view.reset();
          view.addInfo(this.getStartSearchMsg());
        },

        getStartSearchMsg: function() {
          if (this.custom) {
              return "calendar:Type your keyword above to start your search.";
          } else {
              return "Use the above search field to begin your search";
          }
        },
        /////////////
        // actions //
        /////////////
        onSearchAction: function(e, itemModel) {
            if (itemModel.get('active')) {
                this.zone.$searchText.fadeIn(300);
            } else {
                this.onQuerySubmit(null, "");
                this.view.searchText.model.set("query", "");
                this.zone.$searchText.fadeOut(300);
            }
        },

        onChange: function(content) {
          if (content === "" && !_.isEmpty(this.collection.tags) && this.collection.tags[0] !== "000000000000000000000000") {
            this.onQuerySubmit(null, content);
          } else if (content === "" && _.isEmpty(this.collection.tags)) {
            this.emptiedList();
          }
        },

        onQuerySubmit: function(model, value) {
            if (this.currentQuery === value) return;
            var view = this.view.list;

            view.setQuery(value);
            this.currentQuery = value;
        },

        onSubmitSearch: function() {
            var animations = this.collection,
              filter = animations.getTagsFilter();

            if (_.isEmpty(filter) && _.isEmpty(this.view.searchTextbox.getValue())) {
                animations.resetFilter(); //animations.setFilter(["000000000000000000000000"]);
            } else {
                animations.setFilter(filter, this.view.searchTextbox.getValue());
            }

            if (this.custom) {
                animations.fetch();
            } else {
                animations.getFirstPage();
            }
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onAddCustomExerciseAction: function(e, itemModel) {
            var view = this.view,
                panel = view.add;
            if (!panel) {
                panel = view.add = new VCustomExerciseEditPanel({ group: this.group });
                this.listenTo(panel, { 'form:success': this.onSuccess, });
            }
            view.add.resetModel();
            this.trigger('panel:stack', panel);
        },

        emptiedList: function() {
          this.collection.reset();
          this.view.list.render();
          this.currentQuery = "";
          this.view.alert.reset();
          this.view.alert.addInfo(this.getStartSearchMsg());
        },
        ////////////
        // events //
        ////////////
        onAddSelectedExercisesClick: function(e) {
            var list = this.view.list;
            AnimationEvents.addAnimations(list.getSelectedAnimations());
            list.reset();

            if (Viewport.isMobile()) {
                this.trigger('back');
            }
        },

        onRemoveSelectedExercisesClick: function(e) {
            this.view.list.reset();
        },

        onFilterUpdate: function(collection, options) {
            var animations = this.collection;

            var tagFilter = collection.filter(function(item) {
                return item.get('id').match(/^[a-fA-F0-9]{24}$/);
            }).map(function(item){ return item.get('id'); });

            var searchTextFilter = collection.filter(function(item) {
                return !tagFilter.includes(item.get('id'));
            }).map(function(item){ return item.get('id'); });

            if (_.isEmpty(tagFilter) && _.isEmpty(searchTextFilter)) {
                animations.resetFilter(); //animations.setFilter(["000000000000000000000000"]);
                this.emptiedList();
                return;
            } else {
                animations.setFilter(tagFilter, searchTextFilter);
            }

            if (this.custom) {
                animations.fetch();
            } else {
                animations.getFirstPage();
            }

        },

        onExerciseSelect: function(selectedCollection) {
            var view = this.view.menu,
                hasExercises = selectedCollection.length > 0;
            view.toggleHiddenButton('.btn-cancel', hasExercises);
        },

        onCollectionSync: function(collection) {
            var view = this.view.alert;
            view.reset();

            if (!this.custom && _.isEmpty(this.collection.getFilter()) && _.isEmpty(this.collection.searchText)) {
              view.addInfo(this.getStartSearchMsg());
            } else if (!collection.length) {
                view.addInfo('calendar:No exercises found');
            }
        },

        onSuccess: function() {
          //console.log("Animation-content: onSuccess()");
            this.view.list.render();
        },

    });

    return VExerciseAnimationContent;

});

